import { useCallback } from 'react'
import {
  getFamilyOpportunityIntelligenceReport,
  type FamilyOpportunityIntelligenceReportResult,
} from '@services/api/reports/patients.api'
import type { ReportBucketType } from '@services/api/reports/finance.api'
import { useFinanceReportQuery } from '@hooks/reports/useFinanceReportQuery'

export type FamilyOpportunityIntelligenceReportData =
  FamilyOpportunityIntelligenceReportResult

export type UseFamilyOpportunityIntelligenceReportResult = {
  loading: boolean
  error: string | null
  data: FamilyOpportunityIntelligenceReportData | null
  bucketLabel: string
}

export function useFamilyOpportunityIntelligenceReport(
  toolbarSelection: Record<string, string>,
): UseFamilyOpportunityIntelligenceReportResult {
  const getBucketFromData = useCallback(
    (data: FamilyOpportunityIntelligenceReportResult): ReportBucketType =>
      data.sameFamilyByCategory.bucket,
    [],
  )

  return useFinanceReportQuery({
    toolbarSelection,
    fetchReport: getFamilyOpportunityIntelligenceReport,
    getBucketFromData,
    errorMessage: 'Failed to load family opportunity intelligence data',
  })
}
